module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "record"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('peopleHeader')], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "aboutCourse"
  }, [_c('VShowCell', {
    attrs: {
      "typeIcon": "C",
      "title": "课程相关"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "completeCourse"
  }, [_c('VShowCell', {
    attrs: {
      "typeIcon": "D",
      "title": "已上课程"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e9d4cf6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/MyRecord.vue
// module id = 789
// module chunks = 1